/* eslint-disable */
require('./svg')
